<template>
	<div name="hres72u-popup" id="hres72u-popup" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRES72UC51']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
        	<div class="detail detail-responsive">
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES72UC51']['20'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-100">{{ detailTab2Popup.syncond }}</div>
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES72UC51']['30'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-100">{{ detailTab2Popup.desc_coddcal }}</div>
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES72UC51']['40'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-100">{{ detailTab2Popup.desc_typcal }}</div>
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES72UC51']['50'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-100">{{ detailTab2Popup.desc_typcln }}</div>
						  </div>
						</div>
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES72UC51']['60'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-100">{{ detailTab2Popup.amtmaxn }}</div>
						  </div>
						</div>
					</div>		
				
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'hres72u-popup',
  props: [ 'labels', 'detailTab2Popup' ]
}
</script>





// WEBPACK FOOTER //
// popup.vue?6b361c09